import Immutable from 'immutable';
import {
  CLEAR_FUEL_DATA_COMPLETENESS_REPORT,
  FLAG_FUEL_DATA_COMPLETENESS_REPORT_ACTIVITY,
  POST_FUEL_DATA_COMPLETENESS_REPORT,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_FUEL_DATA_COMPLETENESS_REPORT_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case POST_FUEL_DATA_COMPLETENESS_REPORT:
      // Deep-convert nested API payload (rows[], summary) for Immutable getters in the UI.
      return state.setIn(['current', 'content'], Immutable.fromJS(payload));
    case CLEAR_FUEL_DATA_COMPLETENESS_REPORT:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
